 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0e1bb193":"6887d54e","chunk-0c11f5c4":"e0c1099f","chunk-1915c3eb":"b69fcfb0","chunk-1a0894b4":"9ef10d16","chunk-27dada3e":"4140a435","chunk-2cc68f3c":"a176f18a","chunk-55f65edc":"b0c52213","chunk-59a4d82b":"c8ac6a2e","chunk-6a9b51a6":"f29be392","chunk-6d5a080c":"4889e094","chunk-c221b1ae":"96d854f6","chunk-ec60676c":"bc1ebd9f","chunk-2571ce62":"16a78533","chunk-3c7782ad":"79b87f4f","chunk-453fc6a0":"46df8042","chunk-5690a580":"5f4bfaa5","chunk-661d7368":"7b4355da","chunk-69157fed":"dbdc4f2f","chunk-71a09273":"0af8ac3d","chunk-8f34abb0":"3dc80085","chunk-bbbf6d5e":"0b786c66","chunk-c5b2b592":"1f3735da","chunk-cbc1aef0":"ec6616e5","chunk-4228a4be":"52b4c386","chunk-6050f3c4":"0487e8c7","chunk-0335f3f6":"cdf77ad8","chunk-0a7a1fdd":"01b452fe","chunk-24cb1920":"11d8f604","chunk-28e15a52":"58bc4cd1","chunk-29e83b04":"f2f7ac89","chunk-2af86af0":"ceccc532","chunk-2f2ed3bc":"b61977b2","chunk-2fc3bfc4":"5c297798","chunk-40c9b8b5":"4f8f5ea2","chunk-4796b82c":"702c348d","chunk-5bd6500e":"69de602f","chunk-d26750a4":"20da4670","chunk-63f18d04":"7167b6d8","chunk-197181d2":"3c122037","chunk-22dc58c2":"c921427a","chunk-3557ea18":"1754c189","chunk-b2a1fc6a":"ec22a0b8","chunk-bbe31382":"8e72d530","chunk-d41f9dfa":"640ee776","chunk-d4ab8296":"ae130691","chunk-e316d76c":"0551120f","chunk-f78c7e7a":"de9b93ca","chunk-fee363be":"66c4ae3c","chunk-6a1257d4":"afaacc37","chunk-06cabdc4":"26b68f5b","chunk-1dcb3660":"c6478d35","chunk-2940f6ff":"17684209","chunk-48e7d876":"f0fa2fb6","chunk-55f0dc6a":"c19763e1","chunk-57fb77bb":"03b12c0c","chunk-5f9846e6":"d7ff9fc6","chunk-78848126":"ea50f4f3","chunk-7c4ca4e8":"9ee1a875","chunk-b4f2d50a":"3d9fd328","chunk-cd66d6b0":"55460012","chunk-027eec4f":"ae27cfc3","chunk-055052de":"497bc6a9","chunk-05b8329e":"c5735259","chunk-0c8593fe":"22c7f0c9","chunk-14e58548":"43a9aea3","chunk-40ad2ca4":"02d533db","chunk-61473c63":"5c0f8b69","chunk-8e3e23f0":"bac86ae3","chunk-a747be54":"c2a034a7","chunk-b3680628":"b99926bb","chunk-c8d7a47c":"e1ed59bc","chunk-e69ba558":"debb0a5d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0e1bb193":1,"chunk-0c11f5c4":1,"chunk-1915c3eb":1,"chunk-1a0894b4":1,"chunk-27dada3e":1,"chunk-2cc68f3c":1,"chunk-55f65edc":1,"chunk-59a4d82b":1,"chunk-6a9b51a6":1,"chunk-6d5a080c":1,"chunk-c221b1ae":1,"chunk-ec60676c":1,"chunk-2571ce62":1,"chunk-3c7782ad":1,"chunk-453fc6a0":1,"chunk-5690a580":1,"chunk-661d7368":1,"chunk-69157fed":1,"chunk-71a09273":1,"chunk-8f34abb0":1,"chunk-bbbf6d5e":1,"chunk-c5b2b592":1,"chunk-cbc1aef0":1,"chunk-4228a4be":1,"chunk-6050f3c4":1,"chunk-0335f3f6":1,"chunk-0a7a1fdd":1,"chunk-24cb1920":1,"chunk-28e15a52":1,"chunk-29e83b04":1,"chunk-2af86af0":1,"chunk-2f2ed3bc":1,"chunk-2fc3bfc4":1,"chunk-40c9b8b5":1,"chunk-4796b82c":1,"chunk-5bd6500e":1,"chunk-d26750a4":1,"chunk-63f18d04":1,"chunk-197181d2":1,"chunk-22dc58c2":1,"chunk-3557ea18":1,"chunk-b2a1fc6a":1,"chunk-bbe31382":1,"chunk-d41f9dfa":1,"chunk-d4ab8296":1,"chunk-e316d76c":1,"chunk-f78c7e7a":1,"chunk-fee363be":1,"chunk-6a1257d4":1,"chunk-06cabdc4":1,"chunk-1dcb3660":1,"chunk-2940f6ff":1,"chunk-48e7d876":1,"chunk-55f0dc6a":1,"chunk-57fb77bb":1,"chunk-5f9846e6":1,"chunk-78848126":1,"chunk-7c4ca4e8":1,"chunk-b4f2d50a":1,"chunk-cd66d6b0":1,"chunk-027eec4f":1,"chunk-055052de":1,"chunk-05b8329e":1,"chunk-0c8593fe":1,"chunk-14e58548":1,"chunk-40ad2ca4":1,"chunk-61473c63":1,"chunk-8e3e23f0":1,"chunk-a747be54":1,"chunk-b3680628":1,"chunk-c8d7a47c":1,"chunk-e69ba558":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0e1bb193":"c862c815","chunk-0c11f5c4":"7342fa78","chunk-1915c3eb":"8060bf2b","chunk-1a0894b4":"584aba8c","chunk-27dada3e":"44a6147f","chunk-2cc68f3c":"287f7a08","chunk-55f65edc":"b99780d2","chunk-59a4d82b":"a3653280","chunk-6a9b51a6":"9ed12e67","chunk-6d5a080c":"73ffdd77","chunk-c221b1ae":"c367686f","chunk-ec60676c":"7352ffa5","chunk-2571ce62":"c862c815","chunk-3c7782ad":"767ade5a","chunk-453fc6a0":"12578490","chunk-5690a580":"226f97c1","chunk-661d7368":"b14774cb","chunk-69157fed":"e0eead44","chunk-71a09273":"f5cbbda0","chunk-8f34abb0":"336c4898","chunk-bbbf6d5e":"c474f01d","chunk-c5b2b592":"0f2b097f","chunk-cbc1aef0":"e10b4382","chunk-4228a4be":"23445da6","chunk-6050f3c4":"dbde12b0","chunk-0335f3f6":"ec02e6a6","chunk-0a7a1fdd":"5512ae04","chunk-24cb1920":"a237a579","chunk-28e15a52":"3eff10a3","chunk-29e83b04":"655b0164","chunk-2af86af0":"9a163327","chunk-2f2ed3bc":"26b525f7","chunk-2fc3bfc4":"17b18373","chunk-40c9b8b5":"6ed2ea09","chunk-4796b82c":"86a7feb1","chunk-5bd6500e":"6a6737e9","chunk-d26750a4":"281770a0","chunk-63f18d04":"c862c815","chunk-197181d2":"ea047322","chunk-22dc58c2":"364b680c","chunk-3557ea18":"c5dd01e1","chunk-b2a1fc6a":"5deeb413","chunk-bbe31382":"91c9ef13","chunk-d41f9dfa":"76ff4351","chunk-d4ab8296":"6eb9f49b","chunk-e316d76c":"502d148d","chunk-f78c7e7a":"93ccff14","chunk-fee363be":"46845670","chunk-6a1257d4":"c862c815","chunk-06cabdc4":"c271a6c4","chunk-1dcb3660":"f707f67c","chunk-2940f6ff":"1da1a2a4","chunk-48e7d876":"bfb95f6f","chunk-55f0dc6a":"af0db6b2","chunk-57fb77bb":"74846b5e","chunk-5f9846e6":"b397ff52","chunk-78848126":"b968a278","chunk-7c4ca4e8":"c306a3a5","chunk-b4f2d50a":"12f6cb49","chunk-cd66d6b0":"c862c815","chunk-027eec4f":"20914fc7","chunk-055052de":"98b0d448","chunk-05b8329e":"74f1301b","chunk-0c8593fe":"222832a4","chunk-14e58548":"ce034eac","chunk-40ad2ca4":"a2df9e0e","chunk-61473c63":"89fccb76","chunk-8e3e23f0":"841593cb","chunk-a747be54":"9a4f7749","chunk-b3680628":"534dbd4f","chunk-c8d7a47c":"9660ed6b","chunk-e69ba558":"ef99cf71"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static001.geekbang.org/tgo/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
